import cors from 'cors';
import express from 'express';

export function wonderlicCors(): express.RequestHandler {
  const PROD_ALLOWLIST = [/\.wonderlic\.com$/, /\.wonscore\.io$/];

  return cors({
    origin: (origin, callback) => {
      if (process.env.NODE_ENV === 'development') {
        return callback(null, true);
      }
      // If the origin is undefined, the request is coming from an API and
      // should be allowed through.
      if (origin === undefined) {
        return callback(null, true);
      }
      const foundMatch = PROD_ALLOWLIST.some((urlMatcher) => origin.match(urlMatcher));
      return callback(null, foundMatch);
    },
    credentials: true,
  });
}
